<template>
    <div class="phone-verification-page">
        <div class="phone-verification-page__content">
            <logos-container-ui center />
            <phone-verification-skeleton v-if="loadingAccount" />
            <pending-information-form
            v-else-if="hasIncompleteInformation"
            :user="user"
            @userUpdated="onUserUpdated"
            />
            <phone-verification-form
            v-else
            :user="user"
            :siteId="siteId"
            :redirectUrl="redirectUrl"
            @userUpdated="onUserUpdated"
            />
            <p class="phone-verification-page__support-message">
                {{ $t('If you are still having problems with login, start a support chat') }}.
            </p>
        </div>
    </div>
</template>

<script>
import PhoneVerificationSkeleton from '@/components/ui/skeletons/PhoneVerificationSkeleton.vue';
import PendingInformationForm from '@/components/forms/PendingInformation.vue';
import PhoneVerificationForm from '@/components/forms/PhoneVerification.vue';
import LogosContainerUi from '@/components/ui/LogosContainer.vue'

export default {
    name: 'phone-verification-page',
    components: {
        PhoneVerificationSkeleton,
        PendingInformationForm,
        PhoneVerificationForm,
        LogosContainerUi
    },
    data() {
        return {
            user: null,
            loadingAccount: true,
            siteId: null,
            redirectUrl: null,
        }
    },
    computed: {
        hasIncompleteInformation() {
            return !this.user?.phone || !this.user?.country || !this.user?.first_name;
        },
    },
    async mounted() {
        if (this.$route.query.site_id) {
            this.siteId = this.$route.query.site_id;
        }

        if (this.$route.query.redirect_url) {
            this.redirectUrl = this.$route.query.redirect_url;
        }

        await this.getAccountDetails();
    },
    methods: {
        async getAccountDetails() {
            try {
                this.loadingAccount = true;

                const { data } = await this.axiosAccount.get('/api/accounts/me');

                this.user = data;
            } catch(error) {
                this.handleErrors(error);
            } finally {
                this.loadingAccount = false;
            }
        },
        handleErrors(error) {
            if (error?.response?.status === 404) {
                this.redirectToLogin();
                return;
            }
            this.showError(error);
        },
        redirectToLogin() {
            const query_params = {};
            if (this.user?.email) {
                query_params.email = this.user.email;
            }
            if (this.siteId) {
                query_params.site_id = this.siteId;
            }
            if (this.redirectUrl) {
                query_params.redirect_url = this.redirectUrl;
            }
            this.$router.push({ path: '/login', query: query_params });
        },
        onUserUpdated(userData) {
            this.user = userData;
            if (userData?.phone_verified) {
                this.redirectToLogin();
            }
        }
    }
}
</script>

<style lang="scss">
.phone-verification-page {
    text-align: center;
    position: relative;

    &__back {
        position: absolute;
        left: 0;
        top: 0;
    }

    &__content {
        max-width: 650px;
        margin-left: auto;
        margin-right: auto;
    }

    &__logo {
        margin-bottom: 35px;
    }

    &__support-message {
        color: #c4c4c4;
        font-size: 0.875rem;
        font-weight: 400;
        margin-bottom: 0;
    }

    &__img {
        max-width: 120px;
        width: 100%;
    }
}
</style>
